import ProspectusCover from "../../../../src/images/2023ProspectusCover.jpg";
import * as React from 'react';
export default {
  ProspectusCover,
  React
};